"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcPaginatorV2Behavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_input_select_v2_behavior_1 = require("../bc-input-select-v2/bc-input-select-v2-behavior");
var bc_paginator_v2_constants_1 = require("./bc-paginator-v2-constants");
var bc_paginator_v2_utils_1 = require("./bc-paginator-v2-utils");
var BcPaginatorV2Behavior = (function (_super) {
    __extends(BcPaginatorV2Behavior, _super);
    function BcPaginatorV2Behavior() {
        var _this = _super.call(this) || this;
        _this.previousLinkText = '';
        _this.nextLinkText = '';
        _this.classToSync = '';
        _this.hasMoreRecords = true;
        _this.totalPages = 0;
        _this.siblingCount = 1;
        _this.pageSizeValueUpdated = false;
        _this.paginatorsToSync = [];
        _this.isMainPaginator = false;
        _this.showTopPaginator = true;
        _this.isClicked = false;
        _this.onPreviousClickBasic = _this.onPreviousClickBasic.bind(_this);
        _this.onNextClickBasic = _this.onNextClickBasic.bind(_this);
        return _this;
    }
    BcPaginatorV2Behavior.prototype._setUp = function () {
        _super.prototype._setUp.call(this);
        this.initializeParameters();
        this.setDefaultAttributes();
        if (this.classToSync) {
            this.isMainPaginator = true;
        }
        this.setListenerResize();
        this.createElements();
        this.createSyncPaginators();
    };
    BcPaginatorV2Behavior.prototype.initializeParameters = function () {
        this._id = this.mySelf.getAttribute('id') || this.generateId('bc-paginator');
        if (!this.paginatorType) {
            this.paginatorType = (0, bc_paginator_v2_utils_1.getAttributeHTML)('type', bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_TYPE_BASIC, this.mySelf);
        }
        this.itemsPerPage = this.getItemsPerPage();
        this.totalItems = this.getTotalItemsValue();
        this.currentPage = this.getCurrentPage();
        if (this.showPageSize === null || typeof this.showPageSize === 'undefined') {
            this.showPageSize = (0, bc_paginator_v2_utils_1.getShowRecordsPerPage)(this.mySelf);
        }
        if (this.showInfoItems === null || typeof this.showInfoItems === 'undefined') {
            this.showInfoItems = (0, bc_paginator_v2_utils_1.getShowInfoItems)(this.mySelf);
        }
        if (!this.ariaLabel) {
            this.ariaLabel = (0, bc_paginator_v2_utils_1.getAttributeHTML)('aria-label', bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_ARIA_LABEL, this.mySelf);
        }
        if (!this.classToSync) {
            this.classToSync = (0, bc_paginator_v2_utils_1.getAttributeHTML)('classToSync', '', this.mySelf);
        }
    };
    BcPaginatorV2Behavior.prototype.generateId = function (componentType) {
        var array = new Uint32Array(1);
        var randomNumber = window.crypto.getRandomValues(array);
        return "".concat(componentType, "-").concat(randomNumber[0]);
    };
    BcPaginatorV2Behavior.prototype.getTotalItemsValue = function () {
        return this.totalItems ? (0, bc_paginator_v2_utils_1.getValidNumber)(this.totalItems, 0) : this.getTotalItems();
    };
    BcPaginatorV2Behavior.prototype.getItemsPerPage = function () {
        return this.itemsPerPage
            ? (0, bc_paginator_v2_utils_1.getValidNumber)(this.itemsPerPage, bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_RECORDS_PER_PAGE)
            : (0, bc_paginator_v2_utils_1.getRecordsPerPage)(this.mySelf);
    };
    BcPaginatorV2Behavior.prototype.getCurrentPage = function () {
        var _a;
        return this.currentPage ? (0, bc_paginator_v2_utils_1.getValidNumber)(this.currentPage, 1) : (_a = this.getValidPositiveNumber('initialPage')) !== null && _a !== void 0 ? _a : 1;
    };
    BcPaginatorV2Behavior.prototype.getValidPositiveNumber = function (attributeKey) {
        var attributeValue = this.mySelf.getAttribute(attributeKey);
        var validNumber = (0, bc_paginator_v2_utils_1.isValidNumber)(attributeValue);
        return validNumber ? Number.parseInt(attributeValue) : null;
    };
    BcPaginatorV2Behavior.prototype.getTotalItems = function () {
        var _a, _b;
        if (this.paginatorType === bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_TYPE_BASIC) {
            return (_a = this.getValidPositiveNumber(bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_TOTAL_ITEMS_BASIC)) !== null && _a !== void 0 ? _a : 0;
        }
        return (_b = this.getValidPositiveNumber('totalItems')) !== null && _b !== void 0 ? _b : 0;
    };
    BcPaginatorV2Behavior.prototype.filterPageSizeOptions = function () {
        var filteredOptions = [];
        var pageSizes = this.pageSizeOptions.split(',');
        for (var _i = 0, pageSizes_1 = pageSizes; _i < pageSizes_1.length; _i++) {
            var option = pageSizes_1[_i];
            var pageSizeOpt = Number.parseInt(option);
            if (pageSizeOpt >= this.totalItems) {
                filteredOptions.push(option);
                break;
            }
            filteredOptions.push(option);
        }
        return filteredOptions;
    };
    BcPaginatorV2Behavior.prototype.validateItemsPerPageOptions = function () {
        var _this = this;
        var pageSizeOptionsArray = this.pageSizeOptions.split(',').map(function (option) { return parseInt(option.trim()); });
        if (!pageSizeOptionsArray.includes(this.itemsPerPage)) {
            if (pageSizeOptionsArray.length === bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_MAX_OPTIONS_ITEMS_PER_PAGE) {
                pageSizeOptionsArray.pop();
            }
            var nearestValue = pageSizeOptionsArray.find(function (option) { return option > _this.itemsPerPage; });
            var nearestPosition = nearestValue !== undefined ? pageSizeOptionsArray.indexOf(nearestValue) : -1;
            if (nearestPosition === -1) {
                pageSizeOptionsArray.push(this.itemsPerPage);
            }
            else {
                pageSizeOptionsArray.splice(nearestPosition, 0, this.itemsPerPage);
            }
            this.pageSizeOptions = pageSizeOptionsArray.join(',');
        }
    };
    BcPaginatorV2Behavior.prototype.getPageSizeOptions = function (filterOptions) {
        if (!this.pageSizeOptions) {
            var pageSizeOptionsAttr = (0, bc_paginator_v2_utils_1.getAttributeHTML)('pageSizeOptions', '', this.mySelf);
            if (pageSizeOptionsAttr) {
                var optionsArray = pageSizeOptionsAttr.split(',').map(function (option) { return option.trim(); });
                this.pageSizeOptions = optionsArray.slice(0, bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_MAX_OPTIONS_ITEMS_PER_PAGE).join(',');
            }
            else {
                var defaultOptions = [];
                for (var index = 0; index < bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_MAX_OPTIONS_ITEMS_PER_PAGE; index++) {
                    defaultOptions.push((index + 1) * this.itemsPerPage);
                }
                this.pageSizeOptions = defaultOptions.join(',');
            }
        }
        else {
            var optionsArray = this.pageSizeOptions.split(',').map(function (option) { return option.trim(); });
            this.pageSizeOptions = optionsArray.slice(0, bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_MAX_OPTIONS_ITEMS_PER_PAGE).join(',');
        }
        this.validateItemsPerPageOptions();
        return filterOptions ? this.filterPageSizeOptions() : this.pageSizeOptions.split(',');
    };
    BcPaginatorV2Behavior.prototype.setDefaultAttributes = function () {
        this.mySelf.setAttribute('id', this._id);
        this.mySelf.setAttribute('aria-label', this.ariaLabel);
        this.mySelf.classList.add(bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2);
    };
    BcPaginatorV2Behavior.prototype.isMobileWidth = function (width) {
        return width <= bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_MD_TABLET;
    };
    BcPaginatorV2Behavior.prototype.isTabletOrMobileWidth = function (width) {
        return width <= bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_LG_DESKTOP;
    };
    BcPaginatorV2Behavior.prototype.setShowTopPaginator = function (width) {
        if (this.isTabletOrMobileWidth(width) && this.isMainPaginator) {
            this.showTopPaginator = false;
        }
        else {
            this.showTopPaginator = true;
        }
    };
    BcPaginatorV2Behavior.prototype.setListenerResize = function () {
        var _this = this;
        if (this.paginatorType === bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_TYPE_NUMERIC) {
            this.setElementsToShow();
            window.addEventListener(common_constants_1.BcCommonConstants.EVENT_RESIZE, function () {
                var previousElementsToShow = _this.numElementsToShow;
                var previousShowTopPaginator = _this.showTopPaginator;
                _this.setElementsToShow();
                if (_this.showTopPaginator) {
                    _this.mySelf.classList.remove('hide');
                }
                else {
                    _this.mySelf.classList.add('hide');
                }
                if (previousElementsToShow != _this.numElementsToShow || previousShowTopPaginator != _this.showTopPaginator) {
                    _this.buildNumericPaginator();
                }
            });
        }
    };
    BcPaginatorV2Behavior.prototype.setElementsToShow = function () {
        var widthWindow = (0, bc_paginator_v2_utils_1.getSizeWindows)();
        if (this.isMobileWidth(widthWindow.width)) {
            this.numElementsToShow = bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_MAX_NUM_PAGES_WITHOUT_ELLIPSIS_MOBILE;
            this.staticElementsCount = 3;
            this.siblingCount = 0;
        }
        else {
            this.numElementsToShow = bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_MAX_NUM_PAGES_WITHOUT_ELLIPSIS;
            this.staticElementsCount = 5;
            this.siblingCount = 1;
        }
        this.setShowTopPaginator(widthWindow.width);
    };
    BcPaginatorV2Behavior.prototype.createElements = function () {
        if (this.paginatorType === bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_TYPE_NUMERIC) {
            this.buildNumericPaginator();
        }
        else {
            this.buildBasicPaginator();
        }
    };
    BcPaginatorV2Behavior.prototype.createPreviousLink = function () {
        var bcIcon = (0, bc_paginator_v2_utils_1.createIcon)('arrow2-left');
        var span = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        span.textContent = this.previousLinkText;
        var linkElement = document.createElement(common_constants_1.BcCommonConstants.HREF_TAG);
        linkElement.append(bcIcon, span);
        linkElement.classList.add(common_constants_1.BcCommonConstants.BC_LINK_CLASS, 'link-default', bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_PREV_LINK);
        linkElement.setAttribute('aria-label', bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_PREV_ARIA_LABEL);
        return linkElement;
    };
    BcPaginatorV2Behavior.prototype.createNextLink = function () {
        var bcIcon = (0, bc_paginator_v2_utils_1.createIcon)('arrow2-right');
        var span = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        span.textContent = this.nextLinkText;
        var linkElement = document.createElement(common_constants_1.BcCommonConstants.HREF_TAG);
        linkElement.append(span, bcIcon);
        linkElement.classList.add(common_constants_1.BcCommonConstants.BC_LINK_CLASS, 'link-default', bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_NEXT_LINK);
        linkElement.setAttribute('aria-label', bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_NEXT_ARIA_LABEL);
        return linkElement;
    };
    BcPaginatorV2Behavior.prototype.createPageLinksContainer = function () {
        var pagesContainer = document.createElement('div');
        pagesContainer.classList.add(bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_PAGES_CONTAINER);
        pagesContainer.setAttribute('aria-label', bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_PAGES_ARIA_LABEL);
        pagesContainer.setAttribute('role', 'navigation');
        return pagesContainer;
    };
    BcPaginatorV2Behavior.prototype.buildBasicPaginator = function () {
        this.deleteAllElements();
        this.setBasicPaginatorParameters();
        this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
        this.previousLinkBasic = this.createPreviousLink();
        this.nextLinkBasic = this.createNextLink();
        var pagesContainer = this.createPageLinksContainer();
        pagesContainer.append(this.previousLinkBasic, this.nextLinkBasic);
        this.mySelf.classList.add('basic');
        this.mySelf.append(pagesContainer);
        this.setNextEventBasic();
        this.removePreviousEventBasic();
        this.pageSizeOptionsArr = this.getPageSizeOptions(false);
        if (this.currentPage === this.totalPages) {
            this.noMoreRecords();
        }
        if (this.showPageSize) {
            this.createPageSizeOptionsInputSelect();
            this.configurePageSizeOptionsInputSelect();
        }
    };
    BcPaginatorV2Behavior.prototype.setBasicPaginatorParameters = function () {
        if (!this.previousLinkText) {
            this.previousLinkText = this.mySelf.getAttribute('prevText') || bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_PREV_TEXT;
        }
        if (!this.nextLinkText) {
            this.nextLinkText = this.mySelf.getAttribute('nextText') || bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_NEXT_TEXT;
        }
    };
    BcPaginatorV2Behavior.prototype.onChangeBasicPaginator = function (linkType) {
        if (linkType === 'prev') {
            this.currentPage--;
            if (this.currentPage === 1) {
                this.removePreviousEventBasic();
            }
            if (!this.hasMoreRecords) {
                this.hasMoreRecords = true;
                this.setNextEventBasic();
            }
        }
        else {
            this.currentPage++;
            if (this.currentPage === bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_SECOND_PAGE) {
                this.setPreviousEventBasic();
            }
        }
    };
    BcPaginatorV2Behavior.prototype.onClickLinkBasic = function (linkType) {
        var _this = this;
        if (!this.parentPaginator) {
            this.onChangeBasicPaginator(linkType);
            if (this.isMainPaginator) {
                this.paginatorsToSync.forEach(function (element) {
                    element.onChangeBasicPaginator(linkType);
                });
            }
            if (this.onChangePage != undefined && this.onChangePage != null) {
                var eventData = {
                    id: this._id,
                    previousPage: linkType === 'prev',
                    nextPage: linkType === 'next',
                    currentPage: this.currentPage,
                    itemsPerPage: this.itemsPerPage,
                    noMoreRecords: function () {
                        _this.noMoreRecords();
                    },
                };
                this.onChangePage(eventData);
            }
            else {
                console.error(bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_ONCHANGEPAGE_ERROR);
            }
        }
        else {
            this.parentPaginator.onClickLinkBasic(linkType);
        }
    };
    BcPaginatorV2Behavior.prototype.onPreviousClickBasic = function (event) {
        event.preventDefault();
        this.onClickLinkBasic('prev');
    };
    BcPaginatorV2Behavior.prototype.setPreviousEventBasic = function () {
        (0, bc_paginator_v2_utils_1.enableLink)(this.previousLinkBasic, 'prev');
        this.previousLinkBasic.addEventListener('click', this.onPreviousClickBasic);
    };
    BcPaginatorV2Behavior.prototype.removePreviousEventBasic = function () {
        (0, bc_paginator_v2_utils_1.disableLink)(this.previousLinkBasic);
        this.previousLinkBasic.removeEventListener('click', this.onPreviousClickBasic);
    };
    BcPaginatorV2Behavior.prototype.onNextClickBasic = function (event) {
        event.preventDefault();
        this.onClickLinkBasic('next');
    };
    BcPaginatorV2Behavior.prototype.setNextEventBasic = function () {
        (0, bc_paginator_v2_utils_1.enableLink)(this.nextLinkBasic, 'next');
        this.nextLinkBasic.addEventListener('click', this.onNextClickBasic);
    };
    BcPaginatorV2Behavior.prototype.removeNextEventBasic = function () {
        (0, bc_paginator_v2_utils_1.disableLink)(this.nextLinkBasic);
        this.nextLinkBasic.removeEventListener('click', this.onNextClickBasic);
    };
    BcPaginatorV2Behavior.prototype.noMoreRecords = function () {
        this.hasMoreRecords = false;
        this.removeNextEventBasic();
        if (this.isMainPaginator) {
            this.paginatorsToSync.forEach(function (element) {
                element.noMoreRecords();
            });
        }
    };
    BcPaginatorV2Behavior.prototype.removeCurrentClass = function () {
        this.pagesLinks.forEach(function (link) {
            link.classList.remove('current');
            link.removeAttribute('aria-current');
        });
    };
    BcPaginatorV2Behavior.prototype.updatePages = function (pageIndex) {
        if (this.totalPages > this.numElementsToShow || this.pageSizeValueUpdated) {
            this.buildNumericPaginator();
            this.pageSizeValueUpdated = false;
        }
        else {
            this.removeCurrentClass();
            this.pagesLinks[this.currentPage - 1].classList.add('current');
            this.pagesLinks[this.currentPage - 1].setAttribute('aria-current', 'page');
            this.nextButton.toggleAttribute('disabled', pageIndex === this.totalPages);
            this.previousButton.toggleAttribute('disabled', pageIndex === 1);
            if (this.showInfoItems) {
                var infoTextContainer = this.mySelf.querySelector('.bc-paginator-v2-info');
                this.createInfoItemsText(infoTextContainer);
            }
        }
    };
    BcPaginatorV2Behavior.prototype.syncOtherPaginators = function (pageIndex) {
        this.paginatorsToSync.forEach(function (element) {
            element.currentPage = pageIndex;
            element.updatePages(pageIndex);
        });
    };
    BcPaginatorV2Behavior.prototype.onClickPageNumberLink = function (event, pageIndex) {
        event.preventDefault();
        this.isClicked = true;
        if (!this.parentPaginator) {
            this.currentPage = pageIndex;
            if (this.pagesLinks) {
                this.updatePages(pageIndex);
            }
            if (this.isMainPaginator) {
                this.syncOtherPaginators(pageIndex);
            }
            var eventData = {
                id: this._id,
                currentPage: pageIndex,
                itemsPerPage: this.itemsPerPage,
            };
            this.onChangePage(eventData);
        }
        else {
            this.parentPaginator.onClickPageNumberLink(new MouseEvent('click'), pageIndex);
        }
        this.isClicked = false;
    };
    BcPaginatorV2Behavior.prototype.createGoToPageLink = function (pageIndex) {
        var _this = this;
        var span = document.createElement('span');
        span.textContent = pageIndex.toString();
        var link = document.createElement('a');
        link.setAttribute('href', "#".concat(pageIndex));
        link.setAttribute('aria-label', "".concat(pageIndex));
        link.classList.add(common_constants_1.BcCommonConstants.BC_LINK_CLASS, 'link-default');
        link.appendChild(span);
        link.addEventListener('click', function (event) {
            _this.onClickPageNumberLink(event, pageIndex);
        });
        link.classList.toggle('rectangle', pageIndex >= bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_PAGE_INDEX_100);
        if (pageIndex === this.currentPage) {
            link.classList.add('current');
            link.setAttribute('aria-label', "".concat(bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_PAGE_LINKS_ARIA_LABEL).concat(pageIndex));
            link.setAttribute('aria-current', 'page');
        }
        return link;
    };
    BcPaginatorV2Behavior.prototype.createArrowButton = function (type) {
        var iconNames = { previous: 'arrow2-left', next: 'arrow2-right' };
        var iconName = iconNames[type];
        var icon = (0, bc_paginator_v2_utils_1.createIcon)(iconName);
        var iconClass = {
            previous: bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_PREV_BUTTON,
            next: bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_NEXT_BUTTON,
        };
        var iconClassButton = iconClass[type];
        var ariaLabelOptions = {
            previous: bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_PREV_BUTTON_ARIA_LABEL,
            next: bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_NEXT_BUTTON_ARIA_LABEL,
        };
        var ariaLabel = ariaLabelOptions[type];
        var iconButton = document.createElement('button');
        iconButton.classList.add('bc-icon-button', 'bc-icon-button-ghost', 'bc-icon-button-medium', iconClassButton);
        iconButton.setAttribute('aria-label', ariaLabel);
        iconButton.appendChild(icon);
        return iconButton;
    };
    BcPaginatorV2Behavior.prototype.getPageRanges = function () {
        if (this.totalPages <= this.numElementsToShow) {
            return (0, bc_paginator_v2_utils_1.getRange)(1, this.totalPages);
        }
        var firstPageIndex = 1;
        var lastPageIndex = this.totalPages;
        var pagesDefaultToHide = 2;
        var leftSiblingIndex = this.currentPage - this.siblingCount;
        var rightSiblingIndex = this.currentPage + this.siblingCount;
        var shouldShowLeftEllipsis = leftSiblingIndex > firstPageIndex + pagesDefaultToHide;
        var shouldShowRightEllipsis = rightSiblingIndex < this.totalPages - pagesDefaultToHide;
        if (!shouldShowLeftEllipsis && shouldShowRightEllipsis) {
            var leftItemCount = this.staticElementsCount;
            var leftRange = (0, bc_paginator_v2_utils_1.getRange)(1, leftItemCount);
            return __spreadArray(__spreadArray([], leftRange, true), [null, this.totalPages], false);
        }
        if (shouldShowLeftEllipsis && !shouldShowRightEllipsis) {
            var rightItemCount = this.staticElementsCount;
            var rightRange = (0, bc_paginator_v2_utils_1.getRange)(this.totalPages - rightItemCount + 1, this.totalPages);
            return __spreadArray([firstPageIndex, null], rightRange, true);
        }
        var middleRange = (0, bc_paginator_v2_utils_1.getRange)(leftSiblingIndex, rightSiblingIndex);
        return __spreadArray(__spreadArray([firstPageIndex, null], middleRange, true), [null, lastPageIndex], false);
    };
    BcPaginatorV2Behavior.prototype.createNavigationLinks = function (value) {
        return value === null ? (0, bc_paginator_v2_utils_1.createEllipsis)() : this.createGoToPageLink(value);
    };
    BcPaginatorV2Behavior.prototype.createLinksWithEllipsis = function () {
        var _this = this;
        var pageRanges = this.getPageRanges();
        return pageRanges.map(function (page) { return _this.createNavigationLinks(page); });
    };
    BcPaginatorV2Behavior.prototype.createItemsPerPageSelector = function () {
        var select = document.createElement('div');
        select.setAttribute('id', this.generateId('bc-input-select-v2'));
        select.setAttribute('aria-label', bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_INPUT_SELECT_ARIA_LABEL);
        return select;
    };
    BcPaginatorV2Behavior.prototype.deleteAllElements = function () {
        Array.from(this.mySelf.children).forEach(function (child) { return child.remove(); });
    };
    BcPaginatorV2Behavior.prototype.setCustomTextInfoItems = function () {
        if (!this.customTextInfoItems) {
            this.customTextInfoItems = (0, bc_paginator_v2_utils_1.getAttributeHTML)('customTextInfoItems', '', this.mySelf);
        }
        if (this.customTextInfoItems === '') {
            this.customTextInfoItems = bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_CUSTOM_TEXT_INFO_ITEMS;
        }
    };
    BcPaginatorV2Behavior.prototype.generateInfoItems = function () {
        var startIndex = (this.currentPage - 1) * this.itemsPerPage + 1;
        var endIndex = Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
        this.setCustomTextInfoItems();
        return bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_COMPLETE_TEXT_INFO_ITEMS.replace('[startIndex]', startIndex.toString())
            .replace('[endIndex]', endIndex.toString())
            .replace('[totalItems]', this.totalItems.toString())
            .replace('[textElements]', this.customTextInfoItems);
    };
    BcPaginatorV2Behavior.prototype.hasMoreRecordsThanFirstPageSize = function () {
        var firstPageSize = Number.parseInt(this.pageSizeOptionsArr[0]);
        if (this.totalItems > firstPageSize) {
            return true;
        }
        return false;
    };
    BcPaginatorV2Behavior.prototype.createPageSizeOptionsInputSelect = function () {
        this.pageSizeSelector = this.createItemsPerPageSelector();
        var itemsPerPageContainer = document.createElement('div');
        itemsPerPageContainer.classList.add('bc-paginator-v2-items-page');
        var wrapperInputSelect = document.createElement('div');
        wrapperInputSelect.classList.add('bc-paginator-v2-wrapper-input-select');
        wrapperInputSelect.append(this.pageSizeSelector);
        itemsPerPageContainer.appendChild(wrapperInputSelect);
        this.mySelf.append(itemsPerPageContainer);
        this._updatePositionItems();
    };
    BcPaginatorV2Behavior.prototype._updatePositionItems = function () {
        var observer = new MutationObserver(function (mutationsList) {
            for (var _i = 0, mutationsList_1 = mutationsList; _i < mutationsList_1.length; _i++) {
                var mutation = mutationsList_1[_i];
                if (mutation.type === bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_CHILD_LIST) {
                    mutation.addedNodes.forEach(function (node) {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            var element = node;
                            if (element.classList.contains(bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_FLOAT_MENU)) {
                                element.classList.add(bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_FLOAT_MENU_OVERFLOW);
                            }
                        }
                    });
                }
            }
        });
        observer.observe(this.mySelf, { childList: true, subtree: true });
    };
    BcPaginatorV2Behavior.prototype.createSpanInfoItems = function () {
        var spanTextInfo = document.createElement('span');
        spanTextInfo.classList.add(bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_TEXT_INFO);
        spanTextInfo.textContent = this.generateInfoItems();
        return spanTextInfo;
    };
    BcPaginatorV2Behavior.prototype.createInfoItemsText = function (elementToAppend) {
        var widthWindow = (0, bc_paginator_v2_utils_1.getSizeWindows)();
        if (!this.isMobileWidth(widthWindow.width)) {
            Array.from(elementToAppend.children).forEach(function (child) { return child.remove(); });
            var infoContainer = document.createElement('div');
            infoContainer.classList.add('bc-paginator-v2-info');
            infoContainer.appendChild(this.createSpanInfoItems());
            elementToAppend.append(infoContainer);
        }
    };
    BcPaginatorV2Behavior.prototype.buildNumericPaginator = function () {
        if (this.totalItems <= 0 || !this.showTopPaginator) {
            return;
        }
        this.deleteAllElements();
        this.mySelf.classList.add('numeric');
        this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
        this.pagesLinks = this.createLinksWithEllipsis();
        this.previousButton = this.createArrowButton('previous');
        this.nextButton = this.createArrowButton('next');
        this.configurePreviousButtonBehavior();
        this.configureNextButtonBehavior();
        if (this.showInfoItems) {
            this.createInfoItemsText(this.mySelf);
        }
        var pageLinksContainer = this.createPageLinksContainer();
        pageLinksContainer.append.apply(pageLinksContainer, __spreadArray(__spreadArray([this.previousButton], this.pagesLinks, false), [this.nextButton], false));
        this.mySelf.append(pageLinksContainer);
        this.pageSizeOptionsArr = this.getPageSizeOptions(true);
        if (this.showPageSize && this.hasMoreRecordsThanFirstPageSize()) {
            this.createPageSizeOptionsInputSelect();
            this.configurePageSizeOptionsInputSelect();
        }
        var currentPageLink = this.getMySelf().querySelector(".".concat(bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_PAGES_CONTAINER, " .current"));
        if (currentPageLink && this.isClicked) {
            currentPageLink.focus();
        }
    };
    BcPaginatorV2Behavior.prototype.configurePreviousButtonBehavior = function () {
        var _this = this;
        this.previousButton.addEventListener('click', function (event) {
            _this.onClickPageNumberLink(event, _this.currentPage - 1);
        });
        this.previousButton.toggleAttribute('disabled', this.currentPage == 1);
    };
    BcPaginatorV2Behavior.prototype.configureNextButtonBehavior = function () {
        var _this = this;
        this.nextButton.addEventListener('click', function (event) {
            _this.onClickPageNumberLink(event, _this.currentPage + 1);
        });
        this.nextButton.toggleAttribute('disabled', this.currentPage === this.totalPages);
    };
    BcPaginatorV2Behavior.prototype.goToFirstPageBasic = function () {
        this.currentPage = 1;
        this.setNextEventBasic();
        this.removePreviousEventBasic();
    };
    BcPaginatorV2Behavior.prototype.changePageSizeBasic = function (newItemsPerPage) {
        var _this = this;
        if (!this.parentPaginator) {
            this.itemsPerPage = newItemsPerPage;
            this.pageSizeInputSelect.setSelectedValue(this.itemsPerPage.toString());
            this.goToFirstPageBasic();
            if (this.isMainPaginator) {
                this.paginatorsToSync.forEach(function (element) {
                    element.goToFirstPageBasic();
                    element.itemsPerPage = _this.itemsPerPage;
                    element.pageSizeInputSelect.setSelectedValue(_this.itemsPerPage.toString());
                });
            }
            var eventData = {
                id: this._id,
                previousPage: false,
                nextPage: false,
                currentPage: this.currentPage,
                itemsPerPage: this.itemsPerPage,
                noMoreRecords: function () {
                    _this.noMoreRecords();
                },
            };
            this.onChangePage(eventData);
        }
        else {
            this.parentPaginator.changePageSizeBasic(newItemsPerPage);
        }
    };
    BcPaginatorV2Behavior.prototype.goToFirstPageNumeric = function () {
        this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
        this.pageSizeValueUpdated = true;
        this.updatePages(this.currentPage);
    };
    BcPaginatorV2Behavior.prototype.changePageSizeNumeric = function (newItemsPerPage, pageSizeOptions) {
        var _this = this;
        if (!this.parentPaginator) {
            this.itemsPerPage = newItemsPerPage;
            this.currentPage = 1;
            if (this.pageSizeInputSelect) {
                this.pageSizeInputSelect.setSelectedValue(this.itemsPerPage.toString());
                this.goToFirstPageNumeric();
            }
            else {
                this.pageSizeOptions = pageSizeOptions;
            }
            if (this.isMainPaginator) {
                this.paginatorsToSync.forEach(function (element) {
                    element.itemsPerPage = _this.itemsPerPage;
                    element.currentPage = 1;
                    element.pageSizeInputSelect.setSelectedValue(_this.itemsPerPage.toString());
                    element.goToFirstPageNumeric();
                });
            }
            var eventData = {
                id: this._id,
                currentPage: this.currentPage,
                itemsPerPage: this.itemsPerPage,
            };
            this.onChangePage(eventData);
        }
        else {
            this.parentPaginator.changePageSizeNumeric(newItemsPerPage, this.pageSizeOptions);
        }
    };
    BcPaginatorV2Behavior.prototype.createOptionsPageSize = function () {
        var itemsPageSize = [];
        this.pageSizeOptionsArr.forEach(function (element) {
            itemsPageSize.push({ label: element, value: element });
        });
        return itemsPageSize;
    };
    BcPaginatorV2Behavior.prototype.configurePageSizeOptionsInputSelect = function () {
        var _this = this;
        this.pageSizeInputSelect = new bc_input_select_v2_behavior_1.BcInputSelectV2Behavior();
        this.pageSizeInputSelect.setElement(this.pageSizeSelector);
        this.pageSizeInputSelect.setItems(this.createOptionsPageSize());
        this.pageSizeInputSelect.outputFunction = function (data) {
            _this.itemsPerPage = Number.parseInt(data.value);
            if (_this.paginatorType === bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_TYPE_NUMERIC) {
                _this.changePageSizeNumeric(_this.itemsPerPage, _this.pageSizeOptions);
            }
            else {
                _this.changePageSizeBasic(_this.itemsPerPage);
            }
        };
        this.pageSizeInputSelect.initialValue = this.itemsPerPage.toString();
        this.pageSizeInputSelect.setUp();
    };
    BcPaginatorV2Behavior.prototype.createBasicSyncPaginator = function (container) {
        var paginadorId = this.generateId('bc-paginator');
        var navPaginatorBasic = document.createElement('nav');
        navPaginatorBasic.setAttribute('id', paginadorId);
        navPaginatorBasic.setAttribute(bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_TOTAL_ITEMS_BASIC, this.totalItems.toString());
        container.appendChild(navPaginatorBasic);
        var paginator = new BcPaginatorV2Behavior();
        paginator.setId(paginadorId);
        paginator.paginatorType = 'basic';
        paginator.itemsPerPage = this.itemsPerPage;
        paginator.showPageSize = this.showPageSize;
        paginator.pageSizeOptions = this.pageSizeOptions;
        paginator.previousLinkText = this.previousLinkText;
        paginator.nextLinkText = this.nextLinkText;
        paginator.parentPaginator = this;
        paginator.setUp();
        return paginator;
    };
    BcPaginatorV2Behavior.prototype.createNumericSyncPaginator = function (container) {
        var paginadorId = this.generateId('bc-paginator');
        var navPaginatorBasic = document.createElement('nav');
        navPaginatorBasic.setAttribute('id', paginadorId);
        container.appendChild(navPaginatorBasic);
        var paginator = new BcPaginatorV2Behavior();
        paginator.setId(paginadorId);
        paginator.paginatorType = 'numeric';
        paginator.totalItems = this.totalItems;
        paginator.itemsPerPage = this.itemsPerPage;
        paginator.currentPage = this.currentPage;
        paginator.showPageSize = this.showPageSize;
        paginator.pageSizeOptions = this.pageSizeOptions;
        paginator.showInfoItems = this.showInfoItems;
        paginator.customTextInfoItems = this.customTextInfoItems;
        paginator.parentPaginator = this;
        paginator.setUp();
        return paginator;
    };
    BcPaginatorV2Behavior.prototype.createSyncPaginators = function () {
        var _this = this;
        if (this.classToSync) {
            this.isMainPaginator = true;
            var containerPaginators = document.getElementsByClassName(this.classToSync);
            Array.from(containerPaginators).forEach(function (container) {
                Array.from(container.children).forEach(function (child) { return child.remove(); });
                var newPaginator = _this.paginatorType === 'numeric'
                    ? _this.createNumericSyncPaginator(container)
                    : _this.createBasicSyncPaginator(container);
                _this.paginatorsToSync.push(newPaginator);
            });
        }
    };
    return BcPaginatorV2Behavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcPaginatorV2Behavior = BcPaginatorV2Behavior;
